const initialValues = {
    reportType: 'standard',
    dateSelectionType: 'all',
    placementSelectionType: 'all',
    includesMethodologySlides: false,
    startDate: null,
    endDate: null,
    goal: null,

    selectedTreeRightsholders: [],

    rightsholders: [],
    sponsors: [],
    placement: null,
    filteredPlacements: [],
    broadcastCountryIds: [],
    broadcastCountryNames: [],

    rightsholdersLeaguePairs: [],
    sortBy: 'sponsorMediaValue',

    postImgUrl: null,
    postImgHeight: null,
    postImgWidth: null,
    heroPostId: null,

    reportTitle: '',
    reportUrl: undefined,

    exportAs: 'powerpoint',
    scheduleReportName: undefined,
    scheduleReportStartDate: undefined,
    scheduleReportCadence: 'weekly',
    rhWithSP: [],
    searchDone: false,

    goalName: null,

    timezoneOffset: 0,
};

const initialValuesSendData = {
    rightsholders: {},
    rightsholdersLeaguePairs: [],
    sponsors: [],
    placement: undefined,
    sortBy: 'sponsorMediaValue',
    startDate: new Date(
        new Date().setMonth(new Date().getMonth() - 3),
    ).toISOString(),
    endDate: new Date().toISOString(),
    postImgUrl: undefined,
    postImgHeight: undefined,
    postImgWidth: undefined,
    heroPostId: undefined,
    reportTitle: '',
    reportUrl: undefined,
    placementSelectionType: 'all',
    dateSelectionType: 'specific',
    exportAs: 'powerpoint',
    scheduleReportName: undefined,
    scheduleReportStartDate: undefined,
    scheduleReportCadence: 'weekly',
    rhWithSP: [],
    searchDone: false,
    filteredPlacements: [],
    broadcastCountryIds: [],
    broadcastCountryNames: [],
    reportType: 'standard',
    goal: null,
    goalName: null,
    includesMethodologySlides: false,
    timezoneOffset: 0,
};

export { initialValues, initialValuesSendData };
